import { IGetRegionResponse } from '../../../shared/common/repositories/monolith-python/v1/get-region';
import { IRegion } from '../../types/region';

export function prepareRegion(response: IGetRegionResponse): IRegion {
  return {
    id: response.data.id,
    parentId: response.data.parentId || null,
    fullName: response.data.fullName || null,
    displayName: response.data.displayName || null,
  };
}
